import {
  useVerifyCloudCdnDomainMutation,
  HostingDetailsForSiteDocument,
  HostingDetailsForSiteQuery,
  HostingDetailsForSiteQueryVariables,
} from "@modules/cdn/gatsbyCloudCdn/queries.generated"

export function useValidateCloudCdnDomain(siteId: string) {
  const [verifyCloudCdnDomainMutation] = useVerifyCloudCdnDomainMutation()

  const validateCloudCdnDomain = async (domainName: string) => {
    const result = await verifyCloudCdnDomainMutation({
      variables: {
        siteId,
        domainName,
      },
      refetchQueries: [
        {
          query: HostingDetailsForSiteDocument,
          variables: { siteId },
        },
      ],
      update: (proxy, { data }) => {
        if (!data?.verifyCloudCdnDomain?.success) {
          return
        }

        const queryInfo = {
          query: HostingDetailsForSiteDocument,
          variables: {
            siteId: siteId,
          },
        }

        const queryData = proxy.readQuery<
          HostingDetailsForSiteQuery,
          HostingDetailsForSiteQueryVariables
        >(queryInfo)

        proxy.writeQuery<
          HostingDetailsForSiteQuery,
          HostingDetailsForSiteQueryVariables
        >({
          ...queryInfo,
          data: {
            ...queryData,
            hostingDetailsForSite: queryData?.hostingDetailsForSite?.map(
              details => {
                details.domains = details?.domains?.map(item => {
                  if (item.id === domainName) {
                    item.verified = true
                  }

                  return item
                })
                return details
              }
            ),
          },
        })
      },
    })

    return result?.data?.verifyCloudCdnDomain
  }

  return [validateCloudCdnDomain] as const
}
